import { Button } from '@arcflight/tf-component-library';
import React from 'react';
import styled from 'styled-components';
import defectIcon from '../../../assets/icon-card-defects.svg';
import plusIcon from '../../../assets/plus-blue.svg';
import minusIcon from '../../../assets/icon-minus-blue.svg';
import Card from './Card';

interface AddDeferralTileProps {
  defectDeferred: boolean;
  setDefectDeferred: (value: boolean) => void;
  updateDefectData: (changes: any[]) => void;
}

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const CardTitle = styled.span`
  margin-left: 8px;
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
    margin-left: ${({ iconWidth }): string => (iconWidth === 16 ? '-2px' : '')};
    width: ${({ iconWidth }): string => `${iconWidth}px`};
  }
`;

const AddDeferralTile: React.FC<AddDeferralTileProps> = ({
  defectDeferred,
  setDefectDeferred,
  children,
  updateDefectData,
}) => {
  return (
    <Card padding="20px 20">
      <InnerWrapper>
        <div>
          <img src={defectIcon} alt="defect icon" />
          <CardTitle>Defect Deferral</CardTitle>
        </div>
        {!defectDeferred ? (
          <Button
            primary={false}
            onClick={(): void => {
              setDefectDeferred(true);
              updateDefectData([{ value: true, key: 'deferred' }]);
            }}
            height="24px"
            padding="0 12px"
          >
            <ButtonContent>
              <img src={plusIcon} alt="plus icon" />
              Add deferral
            </ButtonContent>
          </Button>
        ) : (
          <Button
            primary={false}
            onClick={(): void => {
              setDefectDeferred(false);
              updateDefectData([{ value: false, key: 'deferred' }]);
            }}
            height="24px"
            padding="0 12px"
          >
            <ButtonContent iconWidth={16}>
              <img src={minusIcon} alt="plus icon" />
              Remove deferral
            </ButtonContent>
          </Button>
        )}
      </InnerWrapper>
      {children}
    </Card>
  );
};

export default AddDeferralTile;
